import React from 'react';

function FightRow({ fight }) {
  return (
    <div className="fight-row">
      <div>
        <div style={{ fontWeight: 500 }}>{fight.opponent_name}</div>
        <div style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 2 }}>
          {fight.event_date?.slice(0, 10)} · {fight.method}
          {fight.rd_ended && ` R${fight.rd_ended}`}
        </div>
      </div>
      <span className={`fight-result ${fight.result}`}>{fight.result}</span>
    </div>
  );
}

export default function RecentFights({ fights1, fights2, fighter1, fighter2 }) {
  return (
    <div className="card">
      <h2>Recent Fights</h2>
      <div className="fights-grid">
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--teal-light)', marginBottom: 12 }}>
            {fighter1?.full_name}
          </div>
          {fights1?.length > 0
            ? fights1.map((f, i) => <FightRow key={i} fight={f} />)
            : <div style={{ color: 'var(--text-dim)', fontSize: 13 }}>No fight history found</div>
          }
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--orange)', marginBottom: 12 }}>
            {fighter2?.full_name}
          </div>
          {fights2?.length > 0
            ? fights2.map((f, i) => <FightRow key={i} fight={f} />)
            : <div style={{ color: 'var(--text-dim)', fontSize: 13 }}>No fight history found</div>
          }
        </div>
      </div>
    </div>
  );
}
